<template>
    <div>
        <Row type="flex" justify="center">
            <i-col>
                <Spin size="large" fix v-if="carregar_medias"></Spin>
            </i-col>
        </Row>
        <Row type="flex" justify="end" style="margin-bottom: 40px;">
            <i-col>
                <i-select filterable v-model="programador" clearable @on-change="filtrarDadosGrafico('analista', programador)" placeholder="Analista" style="width:200px;margin-left:7px;">
                    <Option v-for="(item,key) in tickets_analistas" :value="key" :key="item.value" >{{ item.label }}</Option>
                </i-select>
                <i-select filterable v-model="empresa" clearable @on-change="filtrarDadosGrafico('empresa', empresa)" placeholder="Empresa" style="width:200px;margin-left:7px;">
                    <Option v-for="(item,key) in empresas" :value="key" :key="item.value" >{{ item.label }}</Option>
                </i-select> 
                <i-select filterable v-model="tipo" clearable @on-change="filtrarDadosGrafico('tipo', tipo)" placeholder="Tipo" style="width:200px;margin-left:7px;">
                    <Option v-for="(item,key) in tipos" :value="key" :key="item.value" >{{ item }}</Option>
                </i-select> 
            </i-col>
        </Row>
        <BarChart
            v-if="show_graphs"
            :options="chartData"
            @click="getDetails"
        />
        <TicketsTable :csv="csv" :analistas="tickets_analistas" :loading="loading" :relatores="tickets_pessoas"
                      :tickets="tickets" exibir-andamento v-if="showTable" tempoPGD></TicketsTable>
    </div>
</template>

<script>
    import {moment, toQueryString} from "../../../helpers/utils.js";
    import BarChart from "../../../components/charts/BarChart.vue";
    import { ticket } from '../../../mixins';

    export default {
        components: {
            TicketsTable: () => import("./tickets-table.vue"),
            BarChart,
        },
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        data() {
            return {
                programador: 0,
                empresa: 0,
                tipo: 0,
                tipos: ['Todas', 'Bug', 'MVP', 'Solicitação de Serviço', 'Melhoria'],
                label: ["Não Atribuido", "Atribuido", "Em Desenvolvimento", "Análise de Qualidade", "Em Teste", "Aguardando Merge", "Merge Master", "Em Produção"],
                chartData: [],
                show_graphs:true,
                showTable: false,
                loading: false,
                tickets: [],
                empresas: [],
                carregar_medias: false,
                medias:[],
                dadosTickets:[],
                csv:false,
            }
        },
        computed: {
            tickets_pessoas() {
                let pesssoas = this.$store.getters['usuarios']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                return _.orderBy(pesssoas, ['label'],['asc'])
            },
            tickets_analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                analistas = _.orderBy(analistas, ['label'],['asc'])
                analistas.unshift({
                    value: -1,
                    label: "Não atribuído"
                });
                return analistas;
            }
        },
        methods: {
            filtrarDadosGrafico(filtro, selecionado) {
                this.selected = null;
                let dadosFiltrados = [];
                this.programador = 0;
                this.empresa = 0;
                this.tipo = 0;

                if (!selecionado) {
                    this.getData(this.dadosTickets);
                    return;
                }

                if (filtro === 'analista') {
                    this.programador = selecionado;
                    const id_programador = this.tickets_analistas[selecionado].value;
                    dadosFiltrados = this.dadosTickets.filter((item) => {
                        if (item.atribuido_a_id === id_programador) {
                            return item;
                        }
                    });
                }

                if (filtro === 'empresa') {
                    this.empresa = selecionado;
                    const id_empresa = this.empresas[selecionado].value;
                    this.dadosTickets.filter((item) => {
                        const solicitante = JSON.parse(item.solicitantes);
                        if (solicitante && solicitante.length > 0) {
                            solicitante.forEach((empresa) => {
                                if (empresa.id_empresa === id_empresa) {
                                    dadosFiltrados.push(item);
                                }
                            });
                        }
                    });
                }

                if (filtro === 'tipo') {
                    this.tipo = selecionado;
                    const tipo_selecionada = this.tipos[selecionado];
                    this.dadosTickets.filter((item) => {
                        if (item.tipo_nome === tipo_selecionada) {
                            dadosFiltrados.push(item);
                        }
                    });
                }

                this.getData(dadosFiltrados);
            },
            getData(dados) {
                const [bug, mvp, ss, mel, totais] = this.getChartDataAndamento(dados);
                this.chartData = {
                    legend: {},
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none'
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            silent: false,
                            axisLine: {onZero: true},
                            splitArea: {show: false},
                            splitLine: {show: false},
                            data: this.label
                        }
                    ],
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value || '',
                    },
                    series: [
                        {
                            name: 'Bug',
                            type: 'bar',
                            color: '#ff1744',
                            data: bug
                        },
                        {
                            name: 'MVP',
                            type: 'bar',
                            color: '#3f51b5',
                            data: mvp
                        },
                        {
                            name: 'Solicitação de Serviço',
                            type: 'bar',
                            color: '#2196f3',
                            data: ss
                        },
                        {
                            name: 'Melhoria',
                            type: 'bar',
                            color: '#ffdf20',
                            data: mel
                        },
                        {
                            name: 'Totais',
                            type: 'line',
                            color: '#263238',
                            data: totais
                        }
                    ],
                    tooltip:{
                        type:'shadow',
                        formatter:(params)=>{
                            let result
                            if(this.tipo==0){
                                var mediatotal = ''
                                var count = 0
                                // calcula media geral
                                if(this.medias.length > 0){
                                    mediatotal = 0
                                    this.medias.forEach(item => {
                                        if(item[params.dataIndex]>0){
                                            mediatotal += item[params.dataIndex]
                                            count++
                                        }
                                    });
                                    if(!isNaN(mediatotal/count))
                                        mediatotal/=count
                                }
                                result= `
                                    ${params.name}<br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ff1744;"></span>Bug: ${bug[params.dataIndex]} ${this.medias.length == 0 ? '': this.medias[0][params.dataIndex]==0?'': '('+this.medias[0][params.dataIndex].toFixed(0)+' hs)'}<br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#3f51b5;"></span>MVP: ${mvp[params.dataIndex]} ${this.medias.length == 0 ? '': this.medias[1][params.dataIndex]==0?'': '('+this.medias[1][params.dataIndex].toFixed(0)+' hs)'}<br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#2196f3;"></span>Solicitação de Serviço: ${ss[params.dataIndex]} ${this.medias.length == 0 ? '': this.medias[3][params.dataIndex]==0?'': '('+this.medias[3][params.dataIndex].toFixed(0)+' hs)'}<br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ffdf20;"></span>Melhoria: ${mel[params.dataIndex]} ${this.medias.length == 0 ? '': this.medias[4][params.dataIndex]==0?'': '('+this.medias[4][params.dataIndex].toFixed(0)+' hs)'}<br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#263238;"></span>Totais: ${totais[params.dataIndex]} ${this.medias.length == 0 ? '': mediatotal==0?'': '('+mediatotal.toFixed(0)+' hs)'}
                                    `
                            }else{
                                result = `
                                            ${params.name}<br>
                                            ${params.marker} ${params.seriesName}: ${params.value} ${this.medias[params.dataIndex] == null? '': isNaN(this.medias[params.dataIndex])? '':'('+this.medias[params.dataIndex].toFixed(0)+' hs)'}
                                            `
                            }
                            return result;
                        }
                    }
                };
            },
            // calcular media dos ticks 
            async getMediaTempo(){
                this.carregar_medias = true
                let media=[]
                const id_programador = this.tickets_analistas[this.programador].value
                const id_empresa = this.empresas[this.empresa].value
                let [bug, mvp, ss, mel] = [[],[],[],[],[]]
                if(this.tipo==0){
                    for (let index = 1; index < this.tipos.length; index++) {
                            for (let j = 0; j < this.label.length; j++) {
                                const tipo_ticket = this.tipos[index]
                                const num_andamento = j
                                const URI = `/ticket/estatisticas/andamentoDetalhe?${toQueryString({
                                    tipo_ticket,
                                    num_andamento,
                                    id_programador,
                                    id_empresa
                                })}`;
                                let result
                                await this.$axios.get(URI)
                                            .then(({data}) => {
                                                this.result = data.map(item => {
                                                    item.solicitantes = item.solicitantes
                                                        ? JSON.parse(item.solicitantes)
                                                        : [];
                                                    item.tempoTotal = this.calculaTempoEstagio(item);
                                                        return item
                                                    });
                                        })
                                            .catch(err => {
                                                console.warn(err);
                                            });
                                let tempoMedio = 0;
                                this.result.forEach((item,key)=>{
                                    if(!isNaN(item.tempoTotal))
                                        tempoMedio += item.tempoTotal  
                                })
                                tempoMedio /= this.result.length
                                switch (index) {
                                    case 1:
                                        if(!isNaN(tempoMedio))
                                            bug.push(tempoMedio);
                                        else
                                            bug.push(0);
                                        break;
                                    case 2:
                                        if(!isNaN(tempoMedio))
                                            mvp.push(tempoMedio);
                                        else
                                            mvp.push(0);
                                        break;
                                    case 4:
                                        if(!isNaN(tempoMedio))
                                            ss.push(tempoMedio);
                                        else
                                            ss.push(0);
                                        break;
                                    case 5:
                                        if(!isNaN(tempoMedio))
                                            mel.push(tempoMedio);
                                        else
                                            mel.push(0);
                                        break;
                                }
                            }
                    }
                    media.push(bug, mvp, ss, mel)
                }else{
                    for (let index = 0; index < this.label.length; index++) {
                                const tipo_ticket = this.tipos[this.tipo]
                                const num_andamento = index
                                const URI = `/ticket/estatisticas/andamentoDetalhe?${toQueryString({
                                    tipo_ticket,
                                    num_andamento,
                                    id_programador,
                                    id_empresa
                                })}`;
                                let result
                                await this.$axios.get(URI)
                                            .then(({data}) => {
                                                this.result = data.map(item => {
                                                    item.solicitantes = item.solicitantes
                                                        ? JSON.parse(item.solicitantes)
                                                        : [];
                                                    item.tempoTotal = this.calculaTempoEstagio(item);
                                                        return item
                                                    });
                                        })
                                            .catch(err => {
                                                console.warn(err);
                                            });
                                let tempoMedio = 0;
                                this.result.forEach(item=>{
                                    tempoMedio += item.tempoTotal
                                })
                                    media.push(tempoMedio /= this.result.length)
                            }
                }
                this.carregar_medias = false
                return media
            },
            getChartDataAndamento(dados) {
                const initial = [0, 0, 0, 0, 0, 0, 0, 0];
                let totalAndamento = 0;

                let bug = [...initial];
                let mvp = [...initial];
                let melhoria = [...initial];
                let ss = [...initial];
                let totais = [...initial];

                let andamento = null;
                dados.forEach((item, key) => {
                    if (andamento === null) {
                        andamento = item.andamento;
                    }

                    if (item.andamento !== andamento) {
                        totais[andamento] = totalAndamento;
                        totalAndamento = 0;
                        andamento = item.andamento;
                    }
                    switch (item.tipo_nome) {
                        case "Bug":
                            bug[andamento]++;
                            break;
                        case "MVP":
                            mvp[andamento]++;
                            break;
                        case "Melhoria":
                            melhoria[andamento]++;
                            break;
                        case "Solicitação de Serviço":
                            ss[andamento]++;
                            break;
                    }
                    totalAndamento++;
                    if (dados.length - 1 === key) {
                        totais[andamento] = totalAndamento;
                    }
                });

                return [bug, mvp, ss, melhoria, totais];
            },
            async getDetails(params) {
                if (!params.selected) {
                    const id_programador = this.tickets_analistas[this.programador].value
                    const id_empresa = this.empresas[this.empresa].value
                    const num_andamento = params.dataIndex;
                    let tipo_ticket = null
                    if(params.seriesType === "line"){
                        tipo_ticket = -1
                    } else {
                        tipo_ticket = this.chartData.series[params.seriesIndex].name
                    }
                const URI = `/ticket/estatisticas/andamentoDetalhe?${toQueryString({
                    tipo_ticket,
                    num_andamento,
                    id_programador,
                    id_empresa
                })}` 
                this.loading = true;
                this.$axios.get(URI)
                    .then(({data}) => {
                        this.tickets = data.map(item => {
                            item.solicitantes = item.solicitantes
                                ? JSON.parse(item.solicitantes)
                                : [];
                            item.tempoTotal = this.calculaTempoEstagio(item);
                            return item
                        });
                        this.showTable = true
                        this.loading = false
                    })
                    .catch(err => {
                        console.warn(err);
                        this.showTable = false
                    })
                } else{
                    this.showTable = false
                }
            },
            calculaTempoEstagio(item) {
                let hoje = moment();
                let andamento = item.andamento;
                let timeline = item.timeline;
                if (timeline.length === 0) {// ticket não atribuido
                    return hoje.diff(moment(item.data_hora_cadastro), 'seconds');
                }
                let tempoTotalSec = 0;//total em segundos por ticket
                let ultimo_andamento_registrado = -1;
                timeline.forEach((registro, key) => {
                    if (registro.andamento == andamento || (ultimo_andamento_registrado == andamento && (registro.andamento != andamento))) {
                        //estava anteriormente no andamento que eu quero e agora mudou o andamento
                        if (ultimo_andamento_registrado == andamento && registro.andamento != andamento) {
                            tempoTotalSec += moment(registro.data_hora_registro).diff(moment(timeline[key - 1].data_hora_registro), 'seconds');
                        }
                        //chegou ao fim da timeline,soma ao tempo anterior a diferença de tempo entre a ultima data da timeline e hoje
                        if (timeline.length - 1 == key && registro.andamento == andamento && ultimo_andamento_registrado != andamento) {
                            tempoTotalSec += hoje.diff(moment(registro.data_hora_registro), 'seconds');
                        }
                        //condição para quando só foram feitas mudanças na atribuição do ticket
                        if (tempoTotalSec == 0 && timeline.length - 1 == key && registro.andamento == andamento) {
                            tempoTotalSec += hoje.diff(moment(timeline[0].data_hora_registro), 'seconds');
                        }
                        ultimo_andamento_registrado = registro.andamento;
                    }
                });
                return Math.round(tempoTotalSec / 60 / 60);
            },
            getEmpresas(dados) {
                const dadosEmpresa = dados.filter(ticket => ticket.solicitantes)
                    .map(ticket => {
                        return JSON.parse(ticket.solicitantes);
                    }).reduce((carry, curr) => {
                        Object.values(curr).forEach(empresa => {
                            carry[empresa.id_empresa] = empresa.nome_empresa;
                        });
                        return carry;
                    }, {});

                let empresasList = Object.keys(dadosEmpresa).map((key) => ({
                    value: key.toString(),
                    label: dadosEmpresa[key]
                }));

                empresasList.unshift({
                    value: -1,
                    label: "Solicitantes"
                });

                return empresasList;
            },
            async getTicketsAndamento() {
                try {
                    const URI = `/ticket/andamentoTipo`;
                    const {data} = await this.$axios.get(URI);
                    return Object.values(data);
                } catch (err) {
                    console.warn(err);
                    return [];
                }
            },
        },
        async created() {
            this.dadosTickets = await this.getTicketsAndamento()
            this.empresas = this.getEmpresas(this.dadosTickets)
            this.getData(this.dadosTickets)
        },
        // ao terminar de montar o grafico é chamado a função para calcular as medias dos tickets
        async mounted(){
            this.medias = await this.getMediaTempo()
        },
        watch: {
            dadosTickets() {
                this.empresas = this.getEmpresas(this.dadosTickets);
                this.getData(this.dadosTickets);
            },
            // caso aconteça alteração no grafico é feita um novo calculo para medias dos tickets
            async chartData(){
                this.medias = []
                this.medias = await this.getMediaTempo()
            },
            async refresh(){
                if (this.refresh){
                    this.analista = null
                    this.tipo = null
                    this.showTable = false
                    this.dadosTickets = await this.getTicketsAndamento()
                    this.empresas = this.getEmpresas(this.dadosTickets)
                    this.getData(this.dadosTickets)
                }
            },
            download(){
                this.csv=this.download
            },
            close(){
                if (this.close){
                    this.showTable = false
                    this.show_graphs = false
                } else {
                    this.show_graphs = true
                }    
            },
            showTable(){
                this.$emit('download',this.showTable)
            }
        }
    }
</script>
<style scoped>
    .dropdown {
        padding-left: 45px;
    }

    .corLink {
        color: #3e4444;
    }
    #loading{
        color: transparent;
        min-height: 25px;
    }
</style>
